import { Field, Float, ID, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { Asset, BaseEntity, Tenant, generateEntityId } from '@ztechapps/common.contract'
import { MilkPickupDetail } from './MilkPickupDetail'
import { MilkPickupDelivery } from './MilkPickupDelivery'
import { ManifestNo } from './ManifestNo'
import { Trailer } from './Trailer'
import { HaulerSignature } from './HaulerSignature'
import { MilkPickupRouteRef } from './MilkPickupRouteRef'
import { MilkPickupDriverRef } from './MilkPickupDriverRef'
import { MilkPickupHaulerRef } from './MilkPickupHaulerRef'

@ObjectType()
export class MilkPickup extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('mpkp') })
  declare _id: string

  @Field(() => Tenant, { nullable: true })
  declare tenant?: Tenant

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  ticketNo?: string

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  timeStamp?: Date

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  totalWeight?: number

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  startingWeight?: number

  @Field(() => [MilkPickupDetail], { nullable: true })
  @Prop({ type: [MilkPickupDetail] }, PropType.ARRAY)
  details?: ReturnType<() => MilkPickupDetail[]>

  @Field(() => [MilkPickupDelivery], { nullable: true })
  @Prop({ type: [MilkPickupDelivery] }, PropType.ARRAY)
  deliveries?: ReturnType<() => MilkPickupDelivery[]>

  @Field(() => MilkPickupRouteRef, { nullable: true })
  @Prop({ type: MilkPickupRouteRef })
  route?: ReturnType<() => MilkPickupRouteRef>

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  grossWeight?: number

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  tareWeight?: number

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  netWeight?: number

  @Field(() => [MilkPickupDriverRef], { nullable: true })
  @Prop({ type: [MilkPickupDriverRef] }, PropType.ARRAY)
  drivers?: ReturnType<() => MilkPickupDriverRef[]>

  @Field(() => MilkPickupDriverRef, { nullable: true })
  @Prop({ type: MilkPickupDriverRef })
  driver?: ReturnType<() => MilkPickupDriverRef>

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String] })
  sealNo?: string[]

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  manifestNo?: string

  @Field(() => Trailer, { nullable: true })
  @Prop({ type: Trailer })
  trailer?: ReturnType<() => Trailer>

  @Field(() => [ManifestNo], { nullable: true })
  @Prop({ type: [ManifestNo] }, PropType.ARRAY)
  manifestNos?: ReturnType<() => ManifestNo[]>

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  percentDone?: number

  @Field(() => Boolean, { nullable: true })
  @Prop({ type: Boolean, default: false })
  isPushed?: boolean

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  syncError?: string

  @Field(() => MilkPickupHaulerRef, { nullable: true })
  @Prop({ type: MilkPickupHaulerRef })
  hauler?: ReturnType<() => MilkPickupHaulerRef>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  samplerLicenseNo?: string

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  licenseNoExpirationDate?: Date

  @Field(() => HaulerSignature, { nullable: true })
  @Prop({ type: HaulerSignature })
  driverSignature?: ReturnType<() => HaulerSignature>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  driverOrHelperName?: string

  @Field(() => Boolean, { nullable: true })
  @Prop({ type: Boolean, default: false })
  isSent?: boolean

  @Field(() => [Asset], { nullable: true })
  @Prop({ type: [Asset] }, PropType.ARRAY)
  assets?: ReturnType<() => Asset[]>
}
